module.exports = __webpack_public_path__ + "static/img/pic.0bd0b72d.svg";